<template>
  <v-alert
    v-if="showBackendWarning"
    border="start"
    class="mb-4"
    closable
    data-testid="backend-warning"
    type="warning"
    variant="flat"
    @click:close="warningDismissed = true">
    Daten für folgende Schulen konnten nicht geladen werden: {{ metricsStore.failedLocations.join(', ') }}.
  </v-alert>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import { useMetricsStore } from '@/stores/metrics';

const metricsStore = useMetricsStore();

const warningDismissed = ref(false);
const showBackendWarning = computed(() => metricsStore.failedLocations.length > 0 && !warningDismissed.value);

// Re-surface the warning when the set of failing schools changes (e.g. after a refresh).
watch(
  () => metricsStore.failedLocations.join(','),
  () => {
    warningDismissed.value = false;
  }
);
</script>
